// extracted by mini-css-extract-plugin
module.exports = {"input":"Checkbox_input__2LqxL","label":"Checkbox_label__bLvXe","labelWrapper":"Checkbox_labelWrapper__MJo40"};